import { useEffect, useState } from 'react';
import { getTotalAISuggestionMappedCandidates } from 'wisestep-api';

import CountWithTextCard from '../countWithTextCard';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const JobCrmAiSuggestionMappedCandidates = ({ payload }: IPayloadDTOJobsCrm) => {
  const [count, setCount] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalAISuggestionMappedCandidates(payload);
      setCount(response.data?.aggregations?.aggregation?.buckets.length ?? 0);
    };
    fetchData();
  }, [payload]);
  return <CountWithTextCard count={count} text="Total Mapped AI Suggestions" />;
};
export default JobCrmAiSuggestionMappedCandidates;
